/**
 * constants.js
 *
 * Shared constants used across the application
 */

export const BENEFICIARY_INFO_MESSAGE =
  'All contributions are automatically sent to your PayPal account. No action needed!';

export const CATEGORY_GROUPS = [
  {
    label: 'Support & Emergencies',
    items: [
      'Medical & Recovery',
      'Job Loss & Income Support',
      'Housing & Bills',
      'Pet Care & Vet Bills',
      'Emergency Expenses',
    ],
  },
  {
    label: 'Family & Care',
    items: [
      'Childcare',
      'Elder Care',
      'Memorial & Funeral',
      'New Baby & Adoption',
    ],
  },
  {
    label: 'Home & Life Events',
    items: [
      'Birthday or Celebration',
      'Wedding & Honeymoon',
      // 'New Home',
      'Retirement',
      'Thank You',
    ],
  },
  {
    label: 'Arts & Creative Expression',
    items: [
      'Performing Arts',
      'Creative Projects',
      'Writing & Publishing',
    ],
  },
  {
    label: 'Education & Growth',
    items: [
      'Education & Tuition',
      'Skills & Workshops',
      'Sports & Athletics',
      'Travel & Discovery',
    ],
  },
  {
    label: 'Other',
    items: ['Other'],
  },
];

export const CATEGORIES = CATEGORY_GROUPS.flatMap(g => g.items);

// PayPal fee constants (must match backend/constants.py)
export const PAYPAL_PERCENTAGE_FEE = 0.029;
export const PAYPAL_FIXED_FEE = 0.49;

// Gift amount limits
export const MIN_DONATION_AMOUNT = 5;
export const MIN_GOAL_AMOUNT = 20;
export const MAX_GOAL_AMOUNT = 2000;
export const MAX_POSTS_PER_RECIPIENT_PER_30_DAYS = 2;

// Polling interval for notifications (ms)
export const NOTIFICATION_POLL_INTERVAL = 30000;
